import React from "react"

import DesktopMenu from "./deskTopMenu"
import MobileMenu from "./mobileMenu"

// import './menu.css'
import './menu.css'
import logo from '../../img/redlogo.png'

const MenuList = [
    [
        'HOME', // title
        '/', // Link
    ],
    [
        'ABOUT US',
        '/aboutus',
    ],
    // [
    //     'PORTFOLIO',
    //     '/portfolio',
        
    // ],
    [
        'CONTACT',
        '/contact',
        
    ],
    
    
    
];
const Menu = () => {
    return(
        <div>
            <div className="d-none d-md-block">
                <DesktopMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
            <div className="d-md-none">
                <MobileMenu 
                    siteLogo={logo}
                    menuList={MenuList}
                />
            </div>
        </div>
    )
}

export default Menu;